/** Turn raw usernames / allowlist labels into a person-facing display name. */
export function formatDisplayPersonName(raw: string | null | undefined): string {
  const value = String(raw ?? '').trim();
  if (!value) return '';

  const spaced = value.replace(/[_.]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!spaced) return '';

  const letters = spaced.replace(/[^A-Za-z]/g, '');
  const hasLetter = letters.length > 0;
  const allLower = hasLetter && letters === letters.toLowerCase();
  const allUpper = hasLetter && letters === letters.toUpperCase();

  if (!allLower && !allUpper) return spaced;

  return spaced
    .split(' ')
    .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part))
    .join(' ');
}
